import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const sendChatbotMessage = (message, history = []) => async (dispatch) => {
    dispatch({
        type: 'CHATBOT_LOADING'
    })

    dispatch({
        type: 'CHATBOT_ADD_USER_MESSAGE',
        payload: {
            role: 'user',
            content: message
        }
    })

    try {
        const { data, status } = await Axios.post('/api/chatbot/ask', { message, history },
            {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )

        if (status === 200) {
            dispatch({
                type: 'CHATBOT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHATBOT_NOT_LOADING'
        })

        dispatch({
            type: 'CHATBOT_ADD_BOT_MESSAGE',
            payload: {
                role: 'assistant',
                content: 'Error al obtener respuesta'
            }
        })
    }
}

export const clearChatbotMessages = () => async (dispatch) => {
    dispatch({
        type: 'CHATBOT_CLEAR_MESSAGES'
    })
}